import React from "react";

export const DefaultActividad = ({url}) => {
  //  console.log(url);
   return <> 
     <div></div>
   </>;
};
